import { render, staticRenderFns } from "./LightboxPrev.vue?vue&type=template&id=293e89f8"
import script from "./LightboxPrev.vue?vue&type=script&lang=js"
export * from "./LightboxPrev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports